import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Flower, ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAF7FF] px-6 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-3xl bg-[#7C4DE0] text-white shadow-md">
            <Flower size={34} weight="duotone" />
          </div>
          <h1 className="font-heading text-2xl font-extrabold text-slate-800">Lupa / Set Password</h1>
          <p className="mt-1 text-sm text-slate-500">
            Masukkan email akun Anda. Kami akan mengirim tautan untuk membuat / mereset password.
          </p>
        </div>

        {sent ? (
          <div data-testid="forgot-success" className="rounded-2xl border border-emerald-200 bg-emerald-50 p-5 text-center">
            <EnvelopeSimple size={40} weight="duotone" className="mx-auto text-emerald-600" />
            <p className="mt-2 text-sm text-emerald-800">
              Jika email terdaftar, tautan sudah dikirim ke <b>{email}</b>. Silakan cek kotak masuk (dan folder spam).
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="mb-1.5 block text-xs font-bold uppercase tracking-widest text-slate-500">Email</label>
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@contoh.com"
                className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm outline-none focus:border-rose-400 focus:ring-2 focus:ring-rose-100"
              />
            </div>
            {error && <p className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-600">{error}</p>}
            <button
              data-testid="forgot-submit-button"
              type="submit"
              disabled={loading}
              className="w-full rounded-xl bg-[#7C4DE0] py-3 text-sm font-bold text-white transition-all hover:bg-[#6A38C7] active:scale-95 disabled:opacity-60"
            >
              {loading ? "Mengirim..." : "Kirim Tautan"}
            </button>
          </form>
        )}

        <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm font-semibold text-slate-500 hover:text-[#6A38C7]">
          <ArrowLeft size={16} /> Kembali ke Login
        </Link>
      </div>
    </div>
  );
}
